import axios from 'axios';
import config from './config';

const FEEDBACK_API_URL = `${config.API_BASE_URL}/feedback`;

export async function submitFeedback({ rating, comment, orderId, userId }) {
  try {
    const res = await axios.post(FEEDBACK_API_URL, {
      Rating: rating,
      Comment: comment,
      OrderId: orderId,
      UserId: userId
    });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function getOrderFeedback(orderId) {
  try {
    const res = await axios.get(`${FEEDBACK_API_URL}/order/${orderId}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export async function getUserFeedback(userId) {
  try {
    const res = await axios.get(`${FEEDBACK_API_URL}/user/${userId}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}
